<div class="section-heading">
  ATTACHMENTS:
</div>
<div class="section-content">
  @for (image of pictures; track image) {
    <app-image
      class="attachment"
      [url]="image.preview_url"
    [loaderTheme]="{
             'height': '100%',
             'width': '100%'
          }"
      (click)="openPictures()"
      />
  }
</div>
